
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/homes/[slug]/[homeId]",
      function () {
        return require("private-next-pages/homes/[slug]/[homeId].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/homes/[slug]/[homeId]"])
      });
    }
  